import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { helpers } from "../../../../packages/helpers";
import { useControlContext } from "../../../control";
import { postMessageText, postMessageFile } from "../../actions";
import { isMessageFile, isMessageText } from "../../type-guards";
import { selectChatMessages } from "../../selectors";
import {
  getSendMessageFileData,
  getSendMessageTextData,
} from "../../providers";

const { urlToFile } = helpers.file;

export const useResendMessage = () => {
  const dispatch = useAppDispatch();
  const { api } = useControlContext();
  const { postMessageTextApi, postMessageFileApi } = api;
  const messages = useAppSelector(selectChatMessages);

  const handleResendMessage = (traceId: string) => async () => {
    const message = messages.find((message) => message.traceId === traceId);

    if (!message) {
      return;
    }

    const params = {
      postMessageTextApi,
      postMessageFileApi,

      traceId: message.traceId,
    };

    if (isMessageFile(message)) {
      const { data, name, mime } = message.content.file;
      const fileToSend = await urlToFile(data, name, mime);
      const messageForResend = getSendMessageFileData(message, fileToSend);

      dispatch(postMessageFile({ ...params, message: messageForResend }));

      return;
    }

    if (isMessageText(message)) {
      const messageForResend = getSendMessageTextData(message);

      dispatch(postMessageText({ ...params, message: messageForResend }));

      return;
    }
  };

  return { handleResendMessage };
};
